import {
    Button,
    Field,
    Flex,
    Grid,
    GridItem,
    Input,
    InputGroup,
    Link,
    Text,
    useBreakpointValue,
} from "@chakra-ui/react";
import React, { useState } from "react";

import { Checkbox } from "@/components/ui/checkbox";
import { toaster } from "@/components/ui/toaster";
import { usePostFormDbMutation } from "@/hooks/microservicesApi";

const FormBrokers = () => {
    const [nombreAsesor, setNombreAsesor] = useState("");
    const [telefonoPaisAsesor, setTelefonoPaisAsesor] = useState("52");
    const [telefonoAsesor, setTelefonoAsesor] = useState("");
    const [emailAsesor, setEmailAsesor] = useState("");
    const [apellidoPaterno, setApellidoPaterno] = useState("");
    const [apellidoMaterno, setApellidoMaterno] = useState("");
    const [postFormDb] = usePostFormDbMutation();
    const [isLoading, setIsLoading] = useState(false);

    const isGreaterThanMd = useBreakpointValue({ base: false, md: true });

    const handleSubmit = () => {
        setIsLoading(true);
        const body = {
            code: "COM-GBK-001",
            request: {
                name: nombreAsesor,
                last_name: apellidoPaterno,
                last_name_mother: apellidoMaterno,
                phone: telefonoAsesor,
                email: emailAsesor,
            },
        };

        postFormDb(body)
            .then((resp) => {
                if (resp.data.resp.resp.code == 200) {
                    setIsLoading(false);
                    toaster.create({
                        title: "¡Exito!",
                        description: "Los datos se enviaron exitosamente",
                        type: "success",
                        duration: 4000,
                        closable: true,
                    });
                    setTimeout(function () {
                        window.location.reload();
                    }, 4000);
                } else {
                    setIsLoading(false);
                    toaster.create({
                        title: "Ooops!",
                        description:
                            "Al parecer hubo un error al procesar el envio de los datos... Intenta nuevamente.",
                        type: "error",
                        duration: 4000,
                        closable: true,
                    });
                }
            })
            .catch((err) => {
                console.error(err);
                setIsLoading(false);
                toaster.create({
                    title: "Ooops!",
                    description:
                        "Al parecer hubo un error al procesar el envio de los datos... Intenta nuevamente.",
                    type: "error",
                    duration: 4000,
                    closable: true,
                });
            });
    };

    return (
        <>
            <Text fontSize="3xl" fontWeight={700} textAlign="center" color="black">
                Quiero ser Guía Brokers
            </Text>
            <form
                style={{
                    width: "80%",
                    margin: "auto",
                    marginBottom: "2rem",
                    textAlign: "-webkit-center",
                }}
                onSubmit={(e) => {
                    e.preventDefault();
                    handleSubmit();
                }}
            >
                <Grid
                    templateColumns="repeat(2, 1fr)"
                    gap={4}
                    alignItems="center"
                    pt={5}
                    maxW="4xl"
                    margin="auto"
                    my={4}
                    color="black"
                >
                    <GridItem colSpan={2}>
                        <Text fontWeight={700} fontSize="lg" textAlign="left" mb="4">
                            Datos del asesor interesado
                        </Text>
                        <Field.Root>
                            <Input
                                borderWidth={1.5}
                                borderColor="#D9D9D9"
                                rounded="full"
                                boxShadow="none"
                                _focus={{ borderWidth: 1, borderColor: "gray.400" }}
                                placeholder="Nombre(s)"
                                id="nombre_asesor"
                                type="text"
                                py={6}
                                px={4}
                                value={nombreAsesor}
                                required
                                onChange={(e) => {
                                    e.preventDefault();
                                    setNombreAsesor(e.target.value);
                                }}
                                onBlur={(e) => {
                                    e.preventDefault();
                                    setNombreAsesor(e.target.value);
                                }}
                            />
                        </Field.Root>
                    </GridItem>
                    <GridItem colSpan={1}>
                        <Field.Root>
                            <Input
                                borderWidth={1.5}
                                borderColor="#D9D9D9"
                                rounded="full"
                                boxShadow="none"
                                _focus={{ borderWidth: 1, borderColor: "gray.400" }}
                                placeholder="Apellido paterno"
                                id="lastname"
                                type="text"
                                py={6}
                                px={4}
                                value={apellidoPaterno}
                                required
                                onChange={(e) => {
                                    e.preventDefault();
                                    setApellidoPaterno(e.target.value);
                                }}
                                onBlur={(e) => {
                                    e.preventDefault();
                                    setApellidoPaterno(e.target.value);
                                }}
                            />
                        </Field.Root>
                    </GridItem>
                    <GridItem colSpan={1}>
                        <Field.Root>
                            <Input
                                borderWidth={1.5}
                                borderColor="#D9D9D9"
                                rounded="full"
                                boxShadow="none"
                                _focus={{ borderWidth: 1, borderColor: "gray.400" }}
                                placeholder="Apellido materno"
                                id="apellido_materno"
                                type="text"
                                py={6}
                                px={4}
                                value={apellidoMaterno}
                                required
                                onChange={(e) => {
                                    e.preventDefault();
                                    setApellidoMaterno(e.target.value);
                                }}
                                onBlur={(e) => {
                                    e.preventDefault();
                                    setApellidoMaterno(e.target.value);
                                }}
                            />
                        </Field.Root>
                    </GridItem>
                    <GridItem colSpan={1}>
                        <Field.Root>
                            <InputGroup
                                backgroundColor="#FFFFFF"
                                rounded="full"
                                startAddon={
                                    <Flex
                                        backgroundColor="#FFFFFF"
                                        rounded="full"
                                        borderColor="#D9D9D9"
                                    >
                                        <Flex px={3} color="black" alignItems="center">
                                            +
                                        </Flex>
                                        <Input
                                            borderWidth={0}
                                            padding="0px"
                                            borderRadius="0px"
                                            w="45px"
                                            type="number"
                                            id="telefono_pais_asesor"
                                            paddingRight="10px"
                                            py={6}
                                            value={telefonoPaisAsesor}
                                            required
                                            onChange={(e) => {
                                                e.preventDefault();
                                                setTelefonoPaisAsesor(e.target.value);
                                            }}
                                            onBlur={(e) => {
                                                e.preventDefault();
                                                setTelefonoPaisAsesor(e.target.value);
                                            }}
                                        />
                                    </Flex>
                                }
                                startAddonProps={{
                                    borderRightColor: "#D9D9D9",
                                    borderTopColor: "#D9D9D9",
                                    borderBottomColor: "#D9D9D9",
                                    backgroundColor: "#FFFFFF",
                                    fontFamily: "Montserrat",
                                    color: "black",
                                    rounded: "full",
                                }}
                            >
                                <Input
                                    borderRadius="24px"
                                    placeholder="Teléfono"
                                    borderLeftWidth={0}
                                    borderColor="#D9D9D9"
                                    type="number"
                                    id="telefono_asesor"
                                    py={6}
                                    px={2}
                                    value={telefonoAsesor}
                                    required
                                    onChange={(e) => {
                                        e.preventDefault();
                                        setTelefonoAsesor(e.target.value);
                                    }}
                                    onBlur={(e) => {
                                        e.preventDefault();
                                        setTelefonoAsesor(e.target.value);
                                    }}
                                />
                            </InputGroup>
                        </Field.Root>
                    </GridItem>
                    <GridItem colSpan={1}>
                        <Field.Root>
                            <Input
                                borderWidth={1.5}
                                borderColor="#D9D9D9"
                                rounded="full"
                                boxShadow="none"
                                _focus={{ borderWidth: 1, borderColor: "gray.400" }}
                                placeholder="Correo electónico"
                                id="email_asesor"
                                type="text"
                                py={6}
                                px={4}
                                value={emailAsesor}
                                required
                                onChange={(e) => {
                                    e.preventDefault();
                                    setEmailAsesor(e.target.value);
                                }}
                                onBlur={(e) => {
                                    e.preventDefault();
                                    setEmailAsesor(e.target.value);
                                }}
                            />
                        </Field.Root>
                    </GridItem>
                    <GridItem colSpan={2}>
                        <Field.Root mt={5} alignItems="center">
                            <Checkbox required colorPalette="blue">
                                Acepto los{" "}
                                <Link
                                    color="#317FDA"
                                    href="/terminosycondiciones-guiabroker"
                                    external
                                >
                                    Términos y condiciones.
                                </Link>
                            </Checkbox>
                        </Field.Root>
                    </GridItem>
                </Grid>
                <Button
                    rounded="full"
                    w={isGreaterThanMd ? "60%" : "50%"}
                    py={6}
                    margin="auto"
                    fontWeight="600"
                    color="black"
                    bg="#F7E204"
                    _hover={{
                        bg: "#646464",
                    }}
                    type="submit"
                    loading={isLoading}
                >
                    Enviar
                </Button>
            </form>
        </>
    );
};
export default FormBrokers;
